/* RESPONSIBLE TEAM: team-ai-insights */
// Bridge route for QA received-reviews React view (standalone)
import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class StandaloneMonitorReviewsReceivedRoute extends Route {
  analytics = {
    section: 'standalone',
    place: 'monitor.reviews.received',
  };

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(StandaloneMonitorReviewsReceivedRoute, {
  overrideRenderTemplate: false,
});
